module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAYCAYAAAARfGZ1AAAABHNCSVQICAgIfAhkiAAAATJJREFUSInVlTFuwkAURN9fUqQDCoc2bi3BFeImR0iZsxDOQskRSBQ4QRCR3JLWsSIcoXSxN4W9iNjYrIsgZ5rVfs3Ozn790cIfQmyJ09nTQ3ZAbqo4mmRyf3e7MPsLO+G5LzA2ElUQlM+BYWUjLnTGwJedkeyF1uI5LhtwG4s3hlXPixh5LldOD4DX4I0w2h7ltc/5OthY8c7rfDqb+6D8Qlh6Rd7A6QNU9rsknoVFPWe7fVg+gS6QmsLIcxl6LgCPy5fKCwrOlX+E083XffLWwYYwips5r4Mg6IPo14kanH8UB06foXcNwHsUl0avvSEKoy3hsrqnrQiRtbhGW/9aBgImPB3z0/g1/G9Ojq9egYo1yeQIUa8EcTWic8s7FAk6jX/VS8fSHcIHqPjEg/4BfgBapGfOiaveGwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImg/1.png
// module id = +tZY
// module chunks = 171